var render = function () {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _c(
    "div",
    { staticClass: "container-fluid" },
    [
      _c("div", { staticClass: "row" }, [
        _c(
          "div",
          { staticClass: "col-12 col-no-padding" },
          [
            _c(
              "div",
              { staticClass: "messages", staticStyle: { "margin-top": "0" } },
              [
                _c(
                  "div",
                  {
                    staticClass: "message error",
                    class: { show: _vm.messages.error.length > 0 },
                  },
                  [
                    _c("i", {
                      staticClass: "fa fa-times",
                      on: {
                        click: function ($event) {
                          return _vm.closeMessage("error")
                        },
                      },
                    }),
                    _vm._v(" "),
                    _c("i", {
                      staticClass: "fa fa-exclamation-circle indicator",
                    }),
                    _vm._v(" "),
                    _c("div", { staticClass: "message-inner" }, [
                      _vm.messages.error.length == 1
                        ? _c("span", {
                            domProps: {
                              innerHTML: _vm._s(_vm.messages.error[0].message),
                            },
                          })
                        : _vm._e(),
                      _vm._v(" "),
                      _vm.messages.error.length > 1
                        ? _c(
                            "ul",
                            _vm._l(_vm.messages.error, function (message) {
                              return _c("li", {
                                domProps: {
                                  innerHTML: _vm._s(message.message),
                                },
                              })
                            }),
                            0
                          )
                        : _vm._e(),
                    ]),
                  ]
                ),
              ]
            ),
            _vm._v(" "),
            _c("LoadingMini", { ref: "loading" }),
            _vm._v(" "),
            _c("form", { staticClass: "form" }, [
              _c("div", { staticClass: "form-row row" }, [
                _c("label", { staticClass: "col-12" }, [
                  _vm._v(_vm._s(_vm.$t("plans.form.label"))),
                ]),
                _vm._v(" "),
                _c("input", {
                  directives: [
                    {
                      name: "model",
                      rawName: "v-model",
                      value: _vm.label,
                      expression: "label",
                    },
                    { name: "validate", rawName: "v-validate" },
                  ],
                  ref: "label",
                  staticClass: "form-input col-12",
                  attrs: {
                    type: "text",
                    "data-vv-rules": "required",
                    "data-vv-as": _vm.$t("plans.form.label"),
                  },
                  domProps: { value: _vm.label },
                  on: {
                    input: function ($event) {
                      if ($event.target.composing) {
                        return
                      }
                      _vm.label = $event.target.value
                    },
                  },
                }),
                _vm._v(" "),
                _c(
                  "span",
                  {
                    directives: [
                      {
                        name: "show",
                        rawName: "v-show",
                        value: _vm.showErrors["name"] && _vm.errors.has("name"),
                        expression: "showErrors['name'] && errors.has('name')",
                      },
                    ],
                    staticClass: "form-input-error",
                    on: {
                      click: function ($event) {
                        return _vm.hideError("name")
                      },
                    },
                  },
                  [_vm._v(_vm._s(_vm.errors.first("name")))]
                ),
              ]),
              _vm._v(" "),
              _c("div", { staticClass: "form-row row" }, [
                _c("label", { staticClass: "col-12" }, [
                  _vm._v(_vm._s(_vm.$t("plans.form.plan"))),
                ]),
                _vm._v(" "),
                _c(
                  "div",
                  {
                    staticClass: "form-input-file full-width",
                    class: { selected: _vm.plan != "" },
                  },
                  [
                    _c("input", {
                      directives: [
                        {
                          name: "show",
                          rawName: "v-show",
                          value: !_vm.editMode || _vm.editFull,
                          expression: "!editMode || editFull",
                        },
                      ],
                      ref: "planInput",
                      staticClass: "form-input col-12",
                      attrs: {
                        id: "plan",
                        type: "file",
                        accept: "image/jpg, image/jpeg, image/png",
                      },
                      on: { change: _vm.fileSelected },
                    }),
                    _vm._v(" "),
                    _c("span", {
                      domProps: {
                        innerHTML: _vm._s(_vm.$t("plans.form.planFile")),
                      },
                    }),
                    _vm._v(" "),
                    _c("img", { ref: "planImg", attrs: { src: _vm.plan } }),
                    _vm._v(" "),
                    _c("ScaleSelector", {
                      directives: [
                        {
                          name: "show",
                          rawName: "v-show",
                          value: _vm.scaleDefined,
                          expression: "scaleDefined",
                        },
                      ],
                      attrs: { width: "50%" },
                      model: {
                        value: _vm.scale,
                        callback: function ($$v) {
                          _vm.scale = $$v
                        },
                        expression: "scale",
                      },
                    }),
                  ],
                  1
                ),
              ]),
              _vm._v(" "),
              _c(
                "div",
                {
                  directives: [
                    {
                      name: "show",
                      rawName: "v-show",
                      value: _vm.plan != "",
                      expression: "plan!=''",
                    },
                  ],
                  staticClass: "form-row row",
                },
                [
                  _c("label", { staticClass: "col-12" }, [
                    _vm._v(_vm._s(_vm.$t("plans.form.scale"))),
                  ]),
                  _vm._v(" "),
                  _c("div", { staticClass: "col-12 simple-checkbox" }, [
                    _c("input", {
                      directives: [
                        {
                          name: "model",
                          rawName: "v-model",
                          value: _vm.scaleDefined,
                          expression: "scaleDefined",
                        },
                      ],
                      attrs: {
                        type: "checkbox",
                        name: "sameAddress",
                        id: "sameAddress",
                      },
                      domProps: {
                        checked: Array.isArray(_vm.scaleDefined)
                          ? _vm._i(_vm.scaleDefined, null) > -1
                          : _vm.scaleDefined,
                      },
                      on: {
                        change: [
                          function ($event) {
                            var $$a = _vm.scaleDefined,
                              $$el = $event.target,
                              $$c = $$el.checked ? true : false
                            if (Array.isArray($$a)) {
                              var $$v = null,
                                $$i = _vm._i($$a, $$v)
                              if ($$el.checked) {
                                $$i < 0 &&
                                  (_vm.scaleDefined = $$a.concat([$$v]))
                              } else {
                                $$i > -1 &&
                                  (_vm.scaleDefined = $$a
                                    .slice(0, $$i)
                                    .concat($$a.slice($$i + 1)))
                              }
                            } else {
                              _vm.scaleDefined = $$c
                            }
                          },
                          _vm.toggleScale,
                        ],
                      },
                    }),
                    _vm._v(" "),
                    _c("label", { attrs: { for: "sameAddress" } }, [
                      _vm._v(_vm._s(_vm.$t("plans.form.setScale"))),
                    ]),
                  ]),
                ]
              ),
            ]),
          ],
          1
        ),
      ]),
      _vm._v(" "),
      _c(
        "Toolbar",
        { staticClass: "not-fixed" },
        [
          _c(
            "Btn",
            {
              staticClass: "primary",
              nativeOn: {
                click: function ($event) {
                  $event.stopPropagation()
                  return _vm.valid($event)
                },
              },
            },
            [
              _vm._v(
                "\n            " + _vm._s(_vm.$t("global.save")) + "\n        "
              ),
            ]
          ),
          _vm._v(" "),
          _c(
            "Btn",
            {
              nativeOn: {
                click: function ($event) {
                  $event.stopPropagation()
                  return _vm.cancel($event)
                },
              },
            },
            [
              _vm._v(
                "\n            " +
                  _vm._s(_vm.$t("global.cancel")) +
                  "\n        "
              ),
            ]
          ),
        ],
        1
      ),
    ],
    1
  )
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }